export const headerTranslations = {
    searchDialog: {
        srOnly: { vi: 'Tìm kiếm', bn: 'অনুসন্ধান করুন' },
        chooseTitle: { vi: 'Bạn muốn tìm gì?', bn: 'আপনি কী খুঁজছেন?' },
        chooseDesc: { vi: 'Chọn loại tìm kiếm phù hợp với nhu cầu của bạn.', bn: 'আপনার প্রয়োজন অনুযায়ী সঠিক অনুসন্ধানের ধরনটি বেছে নিন।' },
        findJob: { vi: 'Tìm Việc làm', bn: 'চাকরি খুঁজুন' },
        findJobDesc: { vi: 'Khám phá hàng ngàn cơ hội tại Việt Nam', bn: 'ভিয়েতনামে হাজারো সুযোগ আবিষ্কার করুন' },
        findCandidate: { vi: 'Tìm Ứng viên', bn: 'প্রার্থী খুঁজুন' },
        findCandidateDesc: { vi: 'Tìm kiếm ứng viên phù hợp', bn: 'উপযুক্ত প্রার্থী খুঁজে নিন' },
        jobSearchTitle: { vi: 'Tìm kiếm việc làm', bn: 'চাকরি অনুসন্ধান' },
        jobSearchDesc: { vi: 'Nhập từ khóa, hoặc sử dụng bộ lọc để tìm cơ hội phù hợp nhất.', bn: 'কীওয়ার্ড লিখুন অথবা সবচেয়ে উপযুক্ত সুযোগ খুঁজতে ফিল্টার ব্যবহার করুন।' },
        placeholder: { vi: 'Nhập chức danh, kỹ năng, hoặc tên công ty...', bn: 'পদের নাম, দক্ষতা বা কোম্পানির নাম লিখুন...' },
        visaLabel: { vi: 'Chi tiết loại hình visa', bn: 'ভিসার ধরন বিস্তারিত' },
        visaAll: { vi: 'Tất cả loại hình', bn: 'সকল ধরন' },
        industryLabel: { vi: 'Ngành nghề', bn: 'শিল্প ও পেশা' },
        industryAll: { vi: 'Tất cả ngành nghề', bn: 'সকল পেশা' },
        locationLabel: { vi: 'Địa điểm làm việc', bn: 'কর্মস্থলের অবস্থান' },
        locationAll: { vi: 'Tất cả Nhật Bản', bn: 'সমগ্র জাপান' },
        locationRegionPrefix: { vi: 'Toàn bộ vùng', bn: 'সম্পূর্ণ অঞ্চল' },
        searchBtn: { vi: 'Tìm kiếm', bn: 'অনুসন্ধান করুন' },
    },
    postJobDialog: {
        title: { vi: 'Đăng thông tin tuyển dụng', bn: 'নিয়োগের তথ্য পোস্ট করুন' },
        desc: { vi: 'Vui lòng chọn phương thức đăng thông tin của bạn', bn: 'অনুগ্রহ করে আপনার তথ্য পোস্ট করার পদ্ধতি নির্বাচন করুন' },
        quickPost: { vi: 'Đăng nhanh', bn: 'দ্রুত পোস্ট' },
        quickPostDesc: { vi: 'Dễ dàng, nhanh chóng', bn: 'সহজ, দ্রুত' },
        detailedPost: { vi: 'Đăng chi tiết', bn: 'বিস্তারিত পোস্ট' },
        detailedPostDesc: { vi: 'Đầy đủ thông tin cho ứng viên', bn: 'প্রার্থীদের জন্য সম্পূর্ণ তথ্য' },
    },
    buttons: {
        loginRegister: { vi: 'Đăng nhập / Đăng ký', bn: 'লগইন / নিবন্ধন' },
        login: { vi: 'Đăng nhập', bn: 'লগইন' },
        createProfile: { vi: 'Tạo hồ sơ', bn: 'প্রোফাইল তৈরি করুন' },
        editProfile: { vi: 'Sửa hồ sơ', bn: 'প্রোফাইল সম্পাদন করুন' },
        createShort: { vi: 'Tạo', bn: 'তৈরি করুন' },
        editShort: { vi: 'Sửa', bn: 'সম্পাদন' },
        myJob: { vi: 'Việc của tôi', bn: 'আমার চাকরি' },
        myJobShort: { vi: 'Việc làm', bn: 'কাজ' },
        myJobMobileLoggedOut: { vi: 'Việc', bn: 'কাজ' },
        myJobMobileLoggedIn: { vi: 'Việc làm', bn: 'চাকরি' },
        myJobDesktopLoggedOut: { vi: 'Việc của tôi', bn: 'আমার চাকরি' },
        myJobDesktopLoggedIn: { vi: 'Việc làm của tôi', bn: 'আমার কাজ' },
        postJob: { vi: 'Đăng việc làm', bn: 'চাকরি পোস্ট করুন' },
        manageMyJobs: { vi: 'Quản lý việc làm của tôi', bn: 'আমার চাকরি পরিচালনা' },
        myCandidates: { vi: 'Ứng viên của tôi', bn: 'আমার প্রার্থী' },
        myCandidatesShort: { vi: 'Ứng viên', bn: 'প্রার্থী' },
        myCandidatesMobileLoggedOut: { vi: 'Ứng', bn: 'প্রার্থী' },
        myCandidatesMobileLoggedIn: { vi: 'Ứng viên', bn: 'প্রার্থী' },
        savedCandidates: { vi: 'Ứng viên đã lưu', bn: 'সংরक्षित প্রার্থী' },
        invitedCandidates: { vi: 'Ứng viên đã mời phỏng vấn', bn: 'আমন্ত্রিত প্রার্থী' },
        logout: { vi: 'Đăng xuất', bn: 'লগআউট' },
    },
    user: {
        completeProfile: { vi: 'Hoàn thiện hồ sơ', bn: 'প্রোফাইল সম্পূর্ণ করুন' },
        employerWaiting: { vi: 'Nhà tuyển dụng đang chờ bạn!', bn: 'নিয়োগকর্তারা আপনার জন্য অপেক্ষা করছেন!' },
        defaultUser: { vi: 'Người dùng', bn: 'ব্যবহারকারী' },
        loginPrompt: { vi: 'Đăng nhập để trải nghiệm đầy đủ tính năng của HelloJob.', bn: 'HelloJob-এর সকল সুবিধা উপভোগ করতে লগইন করুন।' },
    },
    avatarMenu: {
        myAccount: { vi: "Tài khoản của tôi", bn: "আমার অ্যাকাউন্ট" },
        viewPublic: { vi: "Hồ sơ công khai", bn: "পাবলিক প্রোফাইল" },
        viewPublicDesc: { vi: "Dành cho nhà tuyển dụng", bn: "নিয়োগকর্তাদের জন্য" },
        viewInternal: { vi: "Hồ sơ nội bộ", bn: "অভ্যন্তরীণ প্রোফাইল" },
        viewInternalDesc: { vi: "Thông tin hệ thống", bn: "সিস্টেম তথ্য" },
        editProfile: { vi: "Cập nhật kỹ năng", bn: "দক্ষতা আপডেট করুন" },
        editProfileDesc: { vi: "Sửa hồ sơ cá nhân", bn: "ব্যক্তিগত তথ্য সম্পাদনা" },
        shareProfile: { vi: "Chia sẻ hồ sơ", bn: "প্রোফাইল শেয়ার করুন" },
        shareProfileDesc: { vi: "Gửi link cho đối tác", bn: "অংশীদারদের লিঙ্ক পাঠান" },
        shareDialogTitle: { vi: "Sao chép Link hồ sơ", bn: "প্রোফাইল লিঙ্ক কপি করুন" },
        publicLink: { vi: "Link công khai", bn: "পাবলিক লিঙ্ক" },
        internalLink: { vi: "Link đối tác", bn: "পার্টনার লিঙ্ক" },
        copy: { vi: "Sao chép", bn: "কপি করুন" },
        copied: { vi: "Đã sao chép!", bn: "কপি করা হয়েছে!" }
    }
};
